import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Milk } from "lucide-react";

export default function Login() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("dueno@lacteopro.mx");
  const [password, setPassword] = useState("admin123");
  const [error, setError] = useState("");

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    const r = await login(email, password);
    if (r.ok) navigate("/");
    else setError(r.error);
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-6 relative overflow-hidden" style={{ background: "radial-gradient(circle at 30% 20%, #eef2ff 0%, #fafaf9 60%)" }} data-testid="login-page">
      <div className="w-full max-w-6xl grid lg:grid-cols-2 items-center gap-8 lg:gap-16">
        {/* LEFT: Brand & welcome */}
        <div className="hidden lg:block">
          <div className="flex items-center gap-2 mb-8">
            <div className="w-10 h-10 rounded-md bg-[#1E3A8A] flex items-center justify-center">
              <Milk className="w-6 h-6 text-white" strokeWidth={1.75} />
            </div>
            <div>
              <div className="font-outfit font-bold text-2xl text-stone-900 tracking-tight">LácteoPro</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-stone-500 font-outfit">ERP Lácteo</div>
            </div>
          </div>
          <h1 className="font-outfit font-bold text-5xl xl:text-6xl tracking-tight leading-[1.05] text-stone-900">
            Cada litro contado.<br />
            <span className="text-[#1E3A8A]">Cada peso medido.</span>
          </h1>
          <p className="mt-6 text-stone-600 text-base max-w-md leading-relaxed">
            La inteligencia operativa y financiera que tu procesadora láctea merece. Trazabilidad completa, decisiones con datos.
          </p>
          <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
            <Metric value="20" label="Módulos" />
            <Metric value="360°" label="Trazabilidad" />
            <Metric value="5" label="Roles" />
          </div>
        </div>

        {/* RIGHT: Login card */}
        <div className="flex items-center justify-center">
          <Card className="w-full max-w-md p-8 border-stone-200 bg-white shadow-lg">
            <div className="lg:hidden mb-6 flex items-center gap-2">
              <div className="w-9 h-9 rounded-md bg-[#1E3A8A] flex items-center justify-center">
                <Milk className="w-5 h-5 text-white" strokeWidth={1.75} />
              </div>
              <span className="font-outfit font-semibold text-lg">LácteoPro</span>
            </div>
            <div className="mb-6">
              <p className="text-[10px] uppercase tracking-[0.18em] font-outfit font-semibold text-stone-500">Iniciar sesión</p>
              <h2 className="font-outfit text-2xl font-semibold tracking-tight text-stone-900 mt-1">Accede a tu planta</h2>
              <p className="text-sm text-stone-500 mt-1">Bienvenido de vuelta</p>
            </div>

            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-xs font-outfit font-semibold uppercase tracking-wider text-stone-600">Correo</Label>
                <Input id="email" data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" />
              </div>
              <div>
                <Label htmlFor="password" className="text-xs font-outfit font-semibold uppercase tracking-wider text-stone-600">Contraseña</Label>
                <Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5" />
              </div>
              {error && (
                <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2" data-testid="login-error">
                  {error}
                </div>
              )}
              <Button type="submit" disabled={loading} data-testid="login-submit-btn" className="w-full bg-[#1E3A8A] hover:bg-[#1E40AF] text-white">
                {loading ? "Entrando..." : "Entrar al sistema"}
              </Button>
            </form>
          </Card>
        </div>
      </div>
    </div>
  );
}

const Metric = ({ value, label }) => (
  <div>
    <div className="font-outfit font-bold text-3xl text-stone-900 tracking-tight">{value}</div>
    <div className="text-[10px] uppercase tracking-wider text-stone-500 font-outfit mt-0.5">{label}</div>
  </div>
);
